// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill';
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import { Pagination, Loading, DatePicker, Input, Button, Form, FormItem, MessageBox, Message, Table, TableColumn, Select, Option, Steps, Step, Alert, Card, Dialog } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'normalize.css/normalize.css'
import '@/assets/iconfont/iconfont'
import IconSvg from '@/components/Icon-svg/index.vue'
// 拿到token后设置token到cookie里面
import { setToken, getToken, removeToken } from '@/utils/auth'
import Cookies from 'js-cookie'
// 根据cookie调用接口拿到token
import { getTokens } from '@/api/login'
import { i18n } from './i18n/index'
import Fastclick from 'fastclick'
import mixin from '@/mixin/'

Vue.mixin(mixin);

// 全局过滤器
Vue.filter('formatMoney', (value, symbol, thousand) => {
  const places = 2;
  /* if(String(value).indexOf(".") == -1) {
      // 如果金额是没有小数位，则输出的格式化则不含小数点
      places = 0
  } */
  symbol = symbol !== undefined ? symbol : '';
  thousand = thousand !== undefined ? thousand : ',';
  const decimal = '.';
  let number = value;
  const negative = number < 0 ? '-' : '';
  const i = parseInt(number = Math.abs(+number || 0).toFixed(places), 10) + '';
  var j = (j = i.length) > 3 ? j % 3 : 0;
  return symbol + negative + (j ? i.substr(0, j) + thousand : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousand) + (places ? decimal + Math.abs(number - i).toFixed(places).slice(2) : '');
})

Vue.config.productionTip = false

Vue.use(Pagination);
Vue.use(Loading);
Vue.use(DatePicker);
Vue.use(Input);
Vue.use(Button);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Select);
Vue.use(Option);
Vue.use(Steps);
Vue.use(Step);
Vue.use(Alert);
Vue.use(Card);
Vue.use(Dialog);
Vue.prototype.$message = Message;
Vue.prototype.$confirm = MessageBox.confirm;

Vue.component('icon-svg', IconSvg);
// 移动端click事件去除300ms延迟插件
Fastclick.attach(document.body)

// 模拟拿到cookies
if (process.env.NODE_ENV === 'development') {
  Cookies.set('cookies', 'JSESSIONID=956A105D73ED70B7C68A8C887C5F7B54%3Bdc4e01dbca1cd374ffb9068b31380fc2=3Y9QTMyYDOygzMxYDMzIyNjZXd0N2XklTP0gDO2ImJ1N3cfRHdwlTZz0mJiR2Xpxmb9s2chFzcyAmJfd3YzVFdp9DZ40DNygiNpZ1ck9XawNTPmEXafN3ZvJXd9ACMpZ1c39GaslTZw0mJhxmb9cmJ5xFdp9DZm0mcs9VZp9DZx0SMzZWYlx2XoNWYu5WZ9wSM1Z2cyV2XklVPhl3bphWYs9Sd1Z2cyV2Xh5Wb9Up5TmZ6yynJpN2Z94UQyQTRwcTN3UUO1IzMycjN5cjMzQUQFRDRCJUOGJ0M=U');
  Cookies.set('Admin-Token', 'eyJhbGciOiJIUzUxMiIsInppcCI6IkRFRiJ9.eNosi0EKwjAUBe_y1lnYb01CzuFGxMW3ZFHQvuA32Cje3RRczjDzgdUrEuIYxZuq7eSkXGflrcLBJpZsSGfowqXdWQ0Xh2r5cWwl93Ho1Ww9wZsvNnJjfSINXmKUvQ_BIa_lL8aDhPD9AQAA__8.QspIaIxj5KhCka5fFPNMXUz6p77Nk5ZkJvOfPYe7VgYf4llpxICFPkAt2isG3RtNW86jX4MpGWriEVSTANapSA');
  // Cookies.set('cookies', '3Y9QTM5UTMykTO5MzN3AiMjZXd0N2XklTP1EDNzYmJ1N3cfRHdwlTZz0mJiR2Xpxmb9sXbzBmJfd3YzVFdp9DZx0TN2QyMpZ1ck9XawNTPmEXafN3ZvJXd9ACMpZ1c39GaslTZw0mJhxmb9cmJ5xFdp9DZm0mcs9VZp9DZ10nJhNGbfV2Yhhmbl5Dbx0nJzVXZfJWa9QWYhZnJzVXZfJmbtFTZl3ZjmX6ulH5jmEnJpN2Z94TO5ADN0IjR0gTM2cTQ4QkM0EURyUUQ1IjQwUDNFd0N=Y')
  // Cookies.set('cookies', 'dc4e01dbca1cd374ffb9068b31380fc2=3Y9QTM5UTM4cDNwgDM5kSOjZXd0N2XklTP1EDNzYmJ1N3cfRHdwlTZz0mJiR2Xpxmb9sXbzBmJfd3YzVFdp9DZx0TN2QyMpZ1ck9XawNTPmEXafN3ZvJXd9ACMpZ1c39GaslTZw0mJhxmb9cmJ5xFdp9DZm0mcs9VZp9DZ10nJhNGbfV2Yhhmbl5Dbx0nJzVXZfJWa9QWYhZnJzVXZfJmbtFTZl3ZjmX6ulH5jmEnJpN2Z94ERyUUMyMTQ3cDN4MDMBdDRxMkN4EkN2QzMEFkNDZjN=I%3BJSESSIONID=AC981E9DEDC7C0CE21BB6847BF713374')
}
// let cookies = Cookies.get('cookies')
// if(cookies){
//   getTokens().then((res)=>{
//     setToken(res.token);
//   })
// }
function isEmptyObject(obj) {
  for (const key in obj) {
    return false;
  }
  return true;
}
if (window.sessionStorage.getItem('adminToken')) {
  store.commit('SET_ADMIN_TOKEN', window.sessionStorage.getItem('adminToken'))
}
// const whiteList = ['/login'];
router.beforeEach((to, from, next) => {
  if (/* store.getters.adminToken */getToken()) {
    if (to.path === '/login') {
      next('/');
    } else {
      // 判断有无获取用户信息
      if (isEmptyObject(store.getters.userInfo)) { // 空的就重新拉去用户信息
        store.dispatch('GetUserInfo').then(data => {
          if (data.status == 1) {
            // 请求之后跳转
            next({ ...to });
          } else {
            // 清空token,清空cookie,不让其跳转
            removeToken();
            Cookies.remove('cookies');
            next({ path: '/login' });
          }
        }).catch(error => {
          if ((error + '').indexOf('401') > -1) {
            getTokens().then(res => {
              setToken(res.token);
              console.log('main.js已经重新获取token');
              next({ ...to }); // 获得token继续跳转，再进入beforeEach，再执行获取信息
            })
          }
        });
      } else {
        if (window.location.search.length && window.location.search.indexOf('uuid') > -1) {
          // 首次进入或再次重新进入的时候会带上search参数
          window.location.replace(window.location.href.replace(window.location.search, ''))
        } else {
          if (store.getters.userInfo.status == 1) {
            // 有用户信息
            next();
          } else {
            // 清空token,退出到login指引页面
            removeToken();
            Cookies.remove('cookies');
            next({ path: '/login' })
          }
        }
      }
    }
  } else {
    if (to.path === '/login') {
      next();
    } else {
      next({
        path: '/login'
      })
    }
  }
});


new Vue({
  el: '#app',
  router,
  i18n,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js